module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.itemClasses
  }, [_c('div', {
    class: _vm.headerClasses,
    on: {
      "click": _vm.toggle
    }
  }, [_c('Icon', {
    attrs: {
      "type": "arrow-right-b"
    }
  }), _vm._v(" "), _vm._t("default")], 2), _vm._v(" "), _c('collapse-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isActive),
      expression: "isActive"
    }],
    class: _vm.contentClasses
  }, [_c('div', {
    class: _vm.boxClasses
  }, [_vm._t("content")], 2)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-564ffd56"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/iview/src/components/collapse/panel.vue
// module id = 632
// module chunks = 1